var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.923 7.54c.357-.553.491-1.087.53-1.51 3.384 2.6 5.6 6.623 5.6 11.222 0 7.746-6.275 14.053-14.053 14.053A14.031 14.031 0 0 1 2.946 17.252c0-4.57 2.219-8.684 5.6-11.228.04.435.18.974.544 1.53.447.685 1.221 1.38 2.521 1.944l.003.001c1.47.616 3.402.918 5.386.918 1.987 0 3.916-.337 5.38-.916l.008-.003c1.318-.565 2.092-1.268 2.535-1.957zM17 .97C8.047.969.75 8.265.75 17.219c0 8.953 7.297 16.25 16.25 16.25s16.25-7.297 16.25-16.25c0-9.02-7.298-16.25-16.25-16.25zm0 2.196c1.771 0 3.367.304 4.51.783.573.24 1.02.519 1.32.815.3.296.44.593.44.88 0 .287-.14.586-.44.885-.3.3-.749.583-1.32.826-1.145.488-2.74.8-4.51.8-1.771 0-3.367-.304-4.51-.787-.572-.242-1.019-.524-1.32-.824-.299-.3-.44-.603-.44-.9 0-.277.138-.57.439-.866.3-.295.749-.575 1.321-.817 1.144-.483 2.74-.795 4.51-.795z",
    fill: "#6238F9",
    stroke: "#6238F9",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.eefed34f27dc37bc789e591d3fdc0118.svg";
export { ForwardRef as ReactComponent };